<template>
  <section class="publication-controls" aria-label="Управление публикацией">
    <p role="status"><strong>{{ label }}</strong><span v-if="record.scheduledAt"> · {{ displayMoscow(record.scheduledAt) }}</span></p>
    <p v-if="record.lastError" role="alert" class="publication-error">{{ record.lastError }}</p>
    <p v-if="notice" role="status">{{ notice }}</p>
    <template v-if="!['PUBLISHING', 'FAILED', 'PUBLISHED'].includes(record.state)">
      <label class="schedule-field">Дата и время автоматической публикации (МСК)
        <input type="datetime-local" :value="schedule" :disabled="busy" @input="$emit('update:schedule', $event.target.value)" />
      </label>
      <p class="publication-hint">До назначенного времени материал скрыт. После запуска потребуется время на обновление страниц сайта.</p>
    </template>
    <div class="publication-actions">
      <template v-if="!['PUBLISHING', 'FAILED', 'PUBLISHED'].includes(record.state)">
        <button type="button" :disabled="busy || draftDisabled" @click="$emit('action', 'draft')">Сохранить черновик</button>
        <button type="button" :disabled="busy || publishDisabled" @click="$emit('action', 'publish')">Опубликовать сейчас</button>
        <button type="button" :disabled="busy || publishDisabled || !schedule" @click="$emit('action', 'schedule')">{{ record.state === 'SCHEDULED' ? 'Сохранить и запланировать' : 'Запланировать' }}</button>
        <button v-if="record.state === 'SCHEDULED'" type="button" :disabled="busy" @click="$emit('action', 'cancel')">Отменить расписание</button>
      </template>
      <button v-if="record.state === 'FAILED'" type="button" :disabled="busy" @click="$emit('action', 'retry')">Повторить публикацию</button>
      <button v-if="record.state === 'FAILED' && !record.startedAt" type="button" :disabled="busy" @click="$emit('action', 'cancel')">Вернуть в черновик</button>
      <button v-if="record.state === 'PUBLISHED'" type="button" :disabled="busy || publishDisabled" @click="$emit('action', 'publish')">Сохранить изменения и обновить сайт</button>
      <span v-if="record.state === 'PUBLISHING'">Публикация уже началась. Можно закрыть админку — работа продолжится на сервере.</span>
    </div>
  </section>
</template>
<script>
import { displayMoscow, PUBLICATION_LABELS } from '@/services/publication-schedule.mjs';
export default {
  props: { record: { type: Object, required: true }, schedule: String, busy: Boolean,
    draftDisabled: Boolean, publishDisabled: Boolean, notice: String },
  emits: ['action', 'update:schedule'],
  computed: { label() { return PUBLICATION_LABELS[this.record.state] || 'Проверяем состояние публикации'; } },
  methods: { displayMoscow },
};
</script>
<style scoped>
.publication-controls { margin: 24px 0; padding: 20px; border: 1px solid #cbd5ce; border-radius: 12px; background: #f6f8f5; overflow-wrap: anywhere; }
.schedule-field { display: flex; flex-direction: column; gap: 8px; max-width: 400px; }
.schedule-field input { min-width: 0; max-width: 100%; padding: 10px; border: 1px solid #738a78; border-radius: 6px; background: white; }
.publication-actions { display: flex; flex-wrap: wrap; gap: 12px; margin-top: 16px; }
.publication-actions button { padding: 10px 16px; border: 1px solid #36543e; border-radius: 8px; color: #29412f; background: white; }
.publication-actions button:disabled { opacity: .5; cursor: not-allowed; }
.publication-actions button:focus-visible { outline: 3px solid #456d53; outline-offset: 3px; }
.publication-error { color: #9d2525; }
.publication-hint { margin-top: 12px; font-size: 14px; }
@media(max-width: 600px) { .publication-actions button { width: 100%; } .publication-controls { padding: 12px; } }
</style>
